import { useState, useCallback } from 'react';
import ReactPlayer from 'react-player';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSpinner, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

import { publicUrlStr } from '../../utils';
import * as S from './style';

interface IVideoPlayer {
  isYt?: boolean;
  videoSource?: string;
  onClose: () => void;
}


//Default: Plays 연구원 30주년 영상 on YT
//VideoSource: YT Video Key OR Video Name (ex: videoName.mp4)
function VideoPlayer({ isYt = true, videoSource = 'lA07Oqsh3jY', onClose}: IVideoPlayer) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const videoUrl = isYt ? `https://www.youtube.com/watch?v=${videoSource}` : `${publicUrlStr()}/videos/${videoSource}.mp4`;

  const handleReady = useCallback(() => {
    setIsLoading(false);
    setHasError(false);
  }, []);

  const handleError = useCallback(() => {
    setIsLoading(false);
    setHasError(true);
  }, []);

  return (
    <S.Overlay
      onClick={onClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <S.ModalContainer onClick={(e) => e.stopPropagation()}>
          <S.CloseButton onClick={onClose}>
            <FontAwesomeIcon icon={faClose} aria-label="close" />
          </S.CloseButton>

        {/* Loading indicator */}
        {isLoading && !hasError && (
          <S.PlayerStatus>
            <FontAwesomeIcon icon={faSpinner} spin size="3x" />
            <span>영상 로딩 중...</span>
          </S.PlayerStatus>
        )}

        {/* Error state */}
        {hasError && (
          <S.PlayerStatus>
            <FontAwesomeIcon icon={faExclamationTriangle} size="3x" style={{ color: '#ff6b6b' }} />
            <span>영상을 재생할 수 없습니다</span>
            <S.RetryButton onClick={() => { setHasError(false); setIsLoading(true); }}>
              다시 시도
            </S.RetryButton>
          </S.PlayerStatus>
        )}

        {!hasError && (
          <ReactPlayer
            url={videoUrl}
            playing
            controls
            volume={1}
            width="100%"
            height="100%"
            className="contentVideo"
            onReady={handleReady}
            onError={handleError}
            config={{ youtube: { playerVars: { autoplay: 1 } } }}
          />
        )}
      </S.ModalContainer>
    </S.Overlay>
  );
}

export default VideoPlayer;